import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { cloneDeep } from 'lodash';
import { editTicketData } from '@/service/ticketService';
import { createKibanaEditContentOperationFormList } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

/**
 *
 * @param {*} viewPermissionTitle
 * @param {*} ticketData
 * @returns
 */


export const isCheckedChangeStatusOption = (viewPermissionTitle, argsAll) => {
    let ticketViewPermission = argsAll.shareStatusData;
    if (
        ticketViewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION[viewPermissionTitle])
    ) {
        return true;
    }
    return false;
};

/**
 *
 * @param {*} ticketKnowledge
 * @returns
 */
export const isAddtionalViewOrEdit = ticketKnowledge => {
    if (
        Utils.isEmptyString(ticketKnowledge.additionalEditPermission) &&
        Utils.isEmptyString(ticketKnowledge.additionalViewPermission)
    ) {
        return false;
    }
    let additionalEditPermission = Utils.convertJSONDataToObject(
        ticketKnowledge.additionalEditPermission
    );
    let additionalViewPermission = Utils.convertJSONDataToObject(
        ticketKnowledge.additionalViewPermission
    );
    for (let keyPermission in additionalEditPermission) {
        if (!Utils.isEmptyArray(additionalEditPermission[keyPermission])) {
            return true;
        }
    }
    for (let keyPermission in additionalViewPermission) {
        if (!Utils.isEmptyArray(additionalViewPermission[keyPermission])) {
            return true;
        }
    }
    return false;
};

/**
 *
 * @param {*} event
 * @param {*} itemData
 * @param {*} setShareStatusPopover
 * @param {*} setOpenShareStatusPopover
 * @param {*} argsAll
 * @returns
 */
export const handleClickShareStatus = (
    event,
    itemData,
    setShareStatusPopover,
    setOpenShareStatusPopover,
    argsAll
) => {
    if (Utils.isEmptyArray(itemData?.editPermission)) {
        setShareStatusPopover(null);
        return;
    }
    setOpenShareStatusPopover(itemData.id);
    setShareStatusPopover(event.currentTarget);
    argsAll.setShareStatusData(itemData.viewPermission);
};

/**
 *
 * @param {*} event
 * @param {*} argsAll
 * @param {*} shareStatusTitle
 * @returns
 */
export const handleClickChecked = (event, argsAll, shareStatusTitle) => {
    let eventTargetChecked = event.target.checked;
    let shareStatusData = cloneDeep(argsAll.shareStatusData);

    if(!eventTargetChecked && argsAll.shareStatusData.length === 1){
        event.stopPropagation();
        event.preventDefault();
        argsAll.setIsOpenAlertDialog(true);
        return;
    }    

    if (eventTargetChecked) {
        shareStatusData.push(shareStatusTitle);
    } else {
        shareStatusData.forEach(oldPermission => {
            if (oldPermission === shareStatusTitle) {
                shareStatusData.splice(shareStatusData.indexOf(oldPermission), 1);
            }
        });
    }
    argsAll.setShareStatusData(shareStatusData);
};

/**
 * 
 * @param {*} event 
 * @param {*} argsAll 
 * @param {*} ticketData 
 */
export const handleClosePopover = async (event, argsAll, ticketData, shareStatusData) => {
    try{
        if(!Utils.compareTwoArraySorted(shareStatusData, ticketData.viewPermission)){
            let params = {
                ticketId: ticketData.id,
                viewPermission: shareStatusData,
                currentUserMail: argsAll.userDetail.mail,
                currentUserId: argsAll.userDetail.id,
                corporationId: ticketData.affiliationOrganization,
                ticketType: ticketData.ticketType,
                updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_SHARE_STATUS
            }
            argsAll.setShareStatusPopover(null);
            argsAll.setOpenShareStatusPopover('');
            argsAll.setShareStatusData([]);
            argsAll.setIsLoading(true);
            await editTicketData(argsAll.API, params);
            let logData = createKibanaEditContentOperationFormList({
                corporationDetail: argsAll.corporationDetail,
                projectDetail: argsAll.projectInuseDetail,
                userDetail: argsAll.userDetail,
                ticketDetail: ticketData,
                publicRange: ''
            });
            let selectedViewPermissionLabelList = Utils.getViewPermissionLabel(shareStatusData);
            let viewPermissionLabel = '';
            selectedViewPermissionLabelList.forEach(permissionLabel => {
                if (Utils.isEmptyString(viewPermissionLabel)) {
                    viewPermissionLabel = permissionLabel;
                } else {
                    viewPermissionLabel = viewPermissionLabel + ', ' + permissionLabel;
                }
            });
            logData.actionDetail = 'edit(changeAccessRange)';
            logData.publicRange = viewPermissionLabel
        
            let param = {
                logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT_FROM_LIST,
                logKibanaData: logData
            };
            createKibanaLogAPI(argsAll.API, param);
            argsAll.setTriggerSearch(Date.now().toString()); 
            argsAll.setIsLoading(false);
            argsAll.reloadTabItemInPanel({
                // panelType: argsAll.isCustomer ? Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                id: ticketData.id
            })
        }
        else{
            argsAll.setShareStatusPopover(null);
            argsAll.setOpenShareStatusPopover('');
            argsAll.setShareStatusData([]);
        }
    }catch(err){
        argsAll.enqueueSnackbar(buildSnackbarMessage(Constant.SERVER_ERROR), {
            variant: 'error',
            autoHideDuration: 3000
        });
        argsAll.setShareStatusPopover(null);
        argsAll.setOpenShareStatusPopover('');
        argsAll.setShareStatusData([]);
    }
};

/**
 *
 * @param {*} event
 * @param {*} itemData
 * @param {*} setShareStatusPopover
 * @param {*} setOpenShareStatusPopover
 * @param {*} argsAll
 * @returns
 */
export const handleClickShowShareStatus = (
    event,
    setIsShowListPublicRange,
    setShareStatusPopover,
    setOpenShareStatusPopover
    
) => {
    setOpenShareStatusPopover(true);
    setIsShowListPublicRange(true)
    setShareStatusPopover(event.currentTarget);
};



export const handleClosePopoverShareStatus = (
    setShareStatusPopover, 
    setOpenShareStatusPopover,
    setIsShowListPublicRange,
    setListDataPublicRange,
    setIsChangePublicRange
) => {
    setShareStatusPopover(null);
    setOpenShareStatusPopover(false);
    setIsShowListPublicRange(false);
    let listDataDefault = localStorageUtil.getListDataPublicRangeDefault();
    setListDataPublicRange(listDataDefault);
    setIsChangePublicRange(false)
};


export const handleClickCheckedRolePublicRange = (
    event,
    shareStatusTitle,
    groupRole,
    selectPermission,
    setDataEditPublicRange,
    dataEditPublicRange,
    listCurrentRole,
    setIsChangePublicRange,
    listCurrentRoleProjectOther
) => {
    let eventTargetChecked = event.target.checked;

    let listDataPublicRangeDefault = localStorageUtil.getListDataPublicRangeDefault();

    let dataRoleUpdate = [];
    let newParams = { ...dataEditPublicRange.params };

    const currentUpdatedData = newParams.dataUpdate ? Utils.convertJSONDataToObject(newParams.dataUpdate) : {};

    switch (groupRole) {
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW:
            dataRoleUpdate = handlerChangeRole(
                eventTargetChecked,
                listCurrentRole,
                shareStatusTitle,
                listCurrentRoleProjectOther
            );
            newParams = {
                ...dataEditPublicRange.params,
                dataUpdate: JSON.stringify({
                    viewPermission: dataRoleUpdate.addedListRole,
                    removedOther: listDataPublicRangeDefault?.listBasicViewOther?.filter(
                        prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                    ),
                    removedCommon: listDataPublicRangeDefault?.listBasicViewCommon.filter(
                        prj => !dataRoleUpdate.addedListRole.includes(prj)
                    )
                })
            };
            break;
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT:
            dataRoleUpdate = handlerChangeRole(
                eventTargetChecked,
                listCurrentRole,
                shareStatusTitle,
                listCurrentRoleProjectOther
            );
            newParams = {
                ...dataEditPublicRange.params,
                dataUpdate: JSON.stringify({
                    editPermission: dataRoleUpdate.addedListRole,
                    removedOther: listDataPublicRangeDefault?.listBasicEditOther?.filter(
                        prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                    ),
                    removedCommon: listDataPublicRangeDefault?.listBasicEditCommon.filter(
                        prj => !dataRoleUpdate.addedListRole.includes(prj)
                    )
                })
            };
            break;

        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.PRJ_IN_ORG:
            dataRoleUpdate = handlerChangeAdditionRole(
                eventTargetChecked,
                listCurrentRole,
                shareStatusTitle,
                Constant.PUBLIC_RANGE_ROLE.IN_ORG,
                listCurrentRoleProjectOther
            );
            if (selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW) {

                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalViewPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.IN_ORG]: listDataPublicRangeDefault.listAdditionalViewOther[Constant.PUBLIC_RANGE_ROLE.IN_ORG].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.IN_ORG]: listDataPublicRangeDefault.listAdditionalViewCommon[Constant.PUBLIC_RANGE_ROLE.IN_ORG].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.IN_ORG].includes(prj)
                            )
                        }
                    })
                };
            } else {
                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalEditPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.IN_ORG]: listDataPublicRangeDefault.listAdditionalEditOther[Constant.PUBLIC_RANGE_ROLE.IN_ORG].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.IN_ORG]: listDataPublicRangeDefault.listAdditionalEditCommon[Constant.PUBLIC_RANGE_ROLE.IN_ORG].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.IN_ORG].includes(prj)
                            )
                        }
                    })
                };
            }
            break;
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_CUSTOMER:
            dataRoleUpdate = handlerChangeAdditionRole(
                eventTargetChecked,
                listCurrentRole,
                shareStatusTitle,
                Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER,
                listCurrentRoleProjectOther
            );
            if (selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW) {
                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalViewPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER]: listDataPublicRangeDefault.listAdditionalViewOther[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER]: listDataPublicRangeDefault.listAdditionalViewCommon[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].includes(prj)
                            )
                        }
                    })
                };
            } else {
                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalEditPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER]: listDataPublicRangeDefault.listAdditionalEditOther[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER]: listDataPublicRangeDefault.listAdditionalEditCommon[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.B2B_CUSTOMER].includes(prj)
                            )
                        }
                    })
                };
            }
            break;
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_SUPPORT:
            dataRoleUpdate = handlerChangeAdditionRole(
                eventTargetChecked,
                listCurrentRole,
                shareStatusTitle,
                Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK,
                listCurrentRoleProjectOther
            );
            if (selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW) {
                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalViewPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK]: listDataPublicRangeDefault.listAdditionalViewOther[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK]: listDataPublicRangeDefault.listAdditionalViewCommon[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].includes(prj)
                            )
                        }
                    })
                };
            } else {
                newParams = {
                    ...dataEditPublicRange.params,
                    dataUpdate: JSON.stringify({
                        additionalEditPermission: dataRoleUpdate.addedListRole,
                        removedOther: {
                            ...currentUpdatedData.removedOther,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK]: listDataPublicRangeDefault.listAdditionalEditOther[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].filter(
                                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
                            )
                        },
                        removedCommon: {
                            ...currentUpdatedData.removedCommon,
                            [Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK]: listDataPublicRangeDefault.listAdditionalEditCommon[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].filter(
                                prj => !dataRoleUpdate.addedListRole[Constant.PUBLIC_RANGE_ROLE.B2B_HELPDESK].includes(prj)
                            )
                        }
                    })
                };
            }
            break;
        default:
            break;
    }
    
    let isChangeData = compareDataChangePublicRange(newParams, groupRole, shareStatusTitle, selectPermission);
    if (isChangeData) {
        setDataEditPublicRange({
            ...dataEditPublicRange,
            params: newParams
        });
    }
    setIsChangePublicRange(isChangeData);
};

export const handleClickCheckedRoleOtherPrj = (
    event,
    shareStatusTitle,
    groupRole,
    selectPermission,
    setDataEditPublicRange,
    dataEditPublicRange,
    listRoleBasePrj,
    listCurrentRole,
    setIsChangePublicRange,
    listDataRoleProjectOther
) => {
    let eventTargetChecked = event.target.checked;
    let dataRoleUpdate = [];

    let listDataPublicRangeDefault = localStorageUtil.getListDataPublicRangeDefault();
    let newParams = { ...dataEditPublicRange.params };
    if (listRoleBasePrj[0].id === shareStatusTitle) {
        dataRoleUpdate = handlerChangeAdditionRole(
            eventTargetChecked,
            listCurrentRole,
            shareStatusTitle,
            Constant.PUBLIC_RANGE_ROLE.BASE_PRJ,
            listDataRoleProjectOther
        );
    } else {
        dataRoleUpdate = handlerChangeAdditionRole(
            eventTargetChecked,
            listCurrentRole,
            shareStatusTitle,
            Constant.PUBLIC_RANGE_ROLE.GUEST_CUSTOMER_PRJ,
            listDataRoleProjectOther
        );
    }

    let removedCommonIds = [];
    let removedOtherIds = [];
    
    if (selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW) {
        
        let listAdditionalViewOther = listDataPublicRangeDefault?.listAdditionalViewOther;
        for (let prjKind in listAdditionalViewOther) {
            let prjArr = listAdditionalViewOther[prjKind];
            removedOtherIds = prjArr.filter(
                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
            );
            listAdditionalViewOther = {
                ...listAdditionalViewOther,
                [prjKind]: [...removedOtherIds]
            }
        }

        let listAdditionalViewCommon = listDataPublicRangeDefault?.listAdditionalViewCommon;
        for (let prjKind in listAdditionalViewCommon) {
            let prjArr = listAdditionalViewCommon[prjKind];
            removedCommonIds = prjArr.filter(
                prj => !dataRoleUpdate.addedListRole[prjKind].includes(prj)
            );
            listAdditionalViewCommon = {
                ...listAdditionalViewCommon,
                [prjKind]: [...removedCommonIds]
            }
        }

        newParams = {
            ...dataEditPublicRange.params,
            dataUpdate: JSON.stringify({
                additionalViewPermission: dataRoleUpdate.addedListRole,
                removedOther: {...listAdditionalViewOther},
                removedCommon: {...listAdditionalViewCommon}
            })
        }
    } else {
        let listAdditionalEditOther = listDataPublicRangeDefault?.listAdditionalEditOther;
        for (let prjKind in listAdditionalEditOther) {
            let prjArr = listAdditionalEditOther[prjKind];
            removedOtherIds = prjArr.filter(
                prj => !dataRoleUpdate.removedListRoleOther.includes(prj)
            )
            listAdditionalEditOther = {
                ...listAdditionalEditOther,
                [prjKind]: [...removedOtherIds]
            }
        }

        let listAdditionalEditCommon = listDataPublicRangeDefault?.listAdditionalEditCommon;
        for (let prjKind in listAdditionalEditCommon) {
            let prjArr = listAdditionalEditCommon[prjKind];
            removedCommonIds = prjArr.filter(
                prj => !dataRoleUpdate.addedListRole[prjKind].includes(prj)
            );
            listAdditionalEditCommon = {
                ...listAdditionalEditCommon,
                [prjKind]: [...removedCommonIds]
            }
        }

        newParams = {
            ...dataEditPublicRange.params,
            dataUpdate: JSON.stringify({
                additionalEditPermission: dataRoleUpdate.addedListRole,
                removedOther: {...listAdditionalEditOther},
                removedCommon: {...listAdditionalEditCommon}
            })
        };
    }

    let isChangeData = compareDataChangePublicRange(newParams, groupRole, shareStatusTitle, selectPermission);
    if (isChangeData) {
        setDataEditPublicRange({
            ...dataEditPublicRange,
            params: newParams
        }); 
    }
    setIsChangePublicRange(isChangeData)
};

const handlerChangeRole = (eventTargetChecked, listCurrentRole, valueRole, listCurrentRoleProjectOther) => {
    if (eventTargetChecked) {
        listCurrentRole.push(valueRole);
    } else {
        listCurrentRole.forEach(oldPermission => {
            if (oldPermission === valueRole) {
                listCurrentRole.splice(listCurrentRole.indexOf(oldPermission), 1);
            }
        });

        listCurrentRoleProjectOther.forEach(oldPermission => {
            if (oldPermission === valueRole) {
                listCurrentRoleProjectOther.splice(listCurrentRoleProjectOther.indexOf(oldPermission), 1);
            }
        });
    }

    return {
        addedListRole: listCurrentRole,
        removedListRoleOther: listCurrentRoleProjectOther
    };
};

const handlerChangeAdditionRole = (eventTargetChecked, listCurrentRole, valueRole, keyRole, listCurrentRoleProjectOther) => {
    if (eventTargetChecked) {
        listCurrentRole[keyRole].push(valueRole);
    } else {
        listCurrentRole[keyRole].forEach(oldPermission => {
            if (oldPermission === valueRole) {
                listCurrentRole[keyRole].splice(listCurrentRole[keyRole].indexOf(oldPermission), 1);
            }
        });

        listCurrentRoleProjectOther.forEach(oldPermission => {
            if (oldPermission === valueRole) {
                listCurrentRoleProjectOther.splice(listCurrentRoleProjectOther.indexOf(oldPermission), 1);
            }
        });
    }
    
    return {
        addedListRole: listCurrentRole,
        removedListRoleOther: listCurrentRoleProjectOther
    };
};

const compareDataChangePublicRange = (params, groupRole, shareStatusTitle, selectPermission) => {
    let listDataDefault = localStorageUtil.getListDataPublicRangeDefault();

    let dataUpdate = Utils.convertJSONDataToObject(params.dataUpdate)
    const keys = Object.keys(dataUpdate)[0];
    let permission = dataUpdate[keys];

    let result = false;
    let listCommon = [];
    let listOther = []
    switch (groupRole) {
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW:
            listCommon = listDataDefault.listBasicViewCommon;
            listOther = listDataDefault.listBasicViewOther;
            if (listOther.includes(shareStatusTitle) || !compareArray(listCommon, permission)) {
                return true;
            }
            break;
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT:
            listCommon = listDataDefault.listBasicEditCommon;
            listOther = listDataDefault.listBasicEditOther;
            if (listOther.includes(shareStatusTitle) || !compareArray(listCommon, permission)) {
                return true;
            }
            break;
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.PRJ_IN_ORG:
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_CUSTOMER:
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_SUPPORT:
        case Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.PRJ_OTHER:
            listCommon = listDataDefault.listAdditionalEditCommon;
            listOther = listDataDefault.listAdditionalEditOther;

            if (selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW) {
                listCommon = listDataDefault.listAdditionalViewCommon;
                listOther = listDataDefault.listAdditionalViewOther;
            }
            if (isValueInObject(shareStatusTitle, listOther) || !deepEqualObject(listCommon, permission)) {
                return true;
            }
            
            break; 
        default:
            break;
    }

    return result;
}

const compareArray = (array1, array2) => {
    let arr1 = array1.sort((a, b) => a - b);
    let arr2 = array2.sort((a, b) => a - b);
    
    return arraysEqual(arr1, arr2);
}

const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((element, index) => element === arr2[index]);
};

const deepEqualObject = (obj1, obj2) => {
    if (obj1 === obj2) {
        return true;
    }

    if (obj1 == null || typeof obj1 !== 'object' ||
        obj2 == null || typeof obj2 !== 'object') {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!keys2.includes(key)) {
            return false;
        }
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
            if (!arrayEqualUnordered(obj1[key], obj2[key])) {
                return false;
            }
        } else if (!deepEqualObject(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

const arrayEqualUnordered = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    let sortedArr1 = arr1.slice().sort();
    let sortedArr2 = arr2.slice().sort();
    for (let i = 0; i < sortedArr1.length; i++) {
        if (!deepEqualObject(sortedArr1[i], sortedArr2[i])) {
            return false;
        }
    }
    return true;
}

const isValueInObject = (value, obj) => {
    let hasValue = false;
    for (let key in obj) {
        if (Array.isArray(obj[key]) && obj[key].includes(value)) {
            hasValue = true;
            break;
        }
    }
    return hasValue
}